export enum ConsentBooleanEnums {
  consent1 = 'consent1',
  consent2 = 'consent2',
  consent3 = 'consent3',
  consent4 = 'consent4'
}

export interface ConsentCheckbox {
  key: number;
  label: string;
  fieldName: ConsentBooleanEnums;
}

export const COVID_CONSENT_CHECKBOX: ConsentCheckbox[] = [
  {
    key: 1,
    label:
      'I attest that, to the best of my knowledge and belief, all data I provide in this form will be accurate and complete.',
    fieldName: ConsentBooleanEnums.consent1
  },
  {
    key: 2,
    label:
      'I understand and agree to the following:\nAll healthcare services come with some risk; One of the risks associated with this screening service is that my screening may fail to accurately and correctly assess my current health status; No promise has been made to me concerning a result, outcome, or cure; I should contact my healthcare provider as soon as possible if my symptoms worsen; I consent to receive healthcare screening services provided by Intermountain Healthcare.',
    fieldName: ConsentBooleanEnums.consent2
  },
  {
    key: 3,
    label:
      'By using this screening tool, I consent to being contacted by Intermountain Healthcare via phone, text, email, and mail.',
    fieldName: ConsentBooleanEnums.consent3
  },
  {
    key: 4,
    label:
      'I understand that COVID-19 testing is not free; Intermountain will attempt to bill my insurance. If my insurance does not cover the cost or I do not have insurance, I will be billed for services. I understand that financial assistance may be available for those that qualify.',
    fieldName: ConsentBooleanEnums.consent4
  }
];
export enum CovidReasonsBooleanEnums {
  covidSymptoms = 'covidSymptoms',
  closeContact = 'closeContact',
  schoolRelated = 'schoolRelated',
  workRelated = 'workRelated',
  travelRelated = 'travelRelated',
  highDensityResidence = 'highDensityResidence'
}
export interface CovidReasonsCheckbox {
  key: number;
  label: string;
  fieldName: CovidReasonsBooleanEnums;
}

export const COVID_REASONS_CHECKBOX: CovidReasonsCheckbox[] = [
  {
    key: 1,
    label: 'I have been experiencing COVID-19 symptoms',
    fieldName: CovidReasonsBooleanEnums.covidSymptoms
  },
  {
    key: 2,
    label: 'I was in close contact with a confirmed COVID-19 case',
    fieldName: CovidReasonsBooleanEnums.closeContact
  },
  {
    key: 3,
    label: 'School related',
    fieldName: CovidReasonsBooleanEnums.schoolRelated
  },
  {
    key: 4,
    label: 'Work related',
    fieldName: CovidReasonsBooleanEnums.workRelated
  },
  {
    key: 5,
    label: 'Travel related',
    fieldName: CovidReasonsBooleanEnums.travelRelated
  },
  {
    key: 6,
    label: 'I live in a high density residence (e.g. college dorm, homeless shelter)',
    fieldName: CovidReasonsBooleanEnums.highDensityResidence
  }
];

export interface CovidSymptoms {
  type: string;
  title: string;
}
export const COVID_SYMPTOMS: CovidSymptoms[] = [
  {
    type: 'subItem',
    title: 'Moderate to severe shortness of breath and difficulty breathing'
  },
  {
    type: 'subItem',
    title: 'Crushing chest pain'
  },
  {
    type: 'subItem',
    title: 'Loss of consciousness'
  },
  {
    type: 'subItem',
    title: 'Slurred speech'
  },
  {
    type: 'subItem',
    title: 'Gasping for air'
  },
  {
    type: 'subItem',
    title: 'Coughing up lots of blood'
  }
];

export enum SymptomsBooleanEnums {
  fever = 'fever',
  cough = 'cough',
  sob = 'shortnessOfBreath',
  foba = 'fatigueOrBodyAches',
  runnyNose = 'runnyNose',
  los = 'lossOfSmell',
  diarrhea = 'diarrhea',
  nob = 'noneOfTheAbove'
}
export interface SymptomsCheckbox {
  key: number;
  label: string;
  fieldName: SymptomsBooleanEnums;
}

export const SYMPTOMS_CHECKBOX: SymptomsCheckbox[] = [
  {
    key: 1,
    label: 'Fever',
    fieldName: SymptomsBooleanEnums.fever
  },
  {
    key: 2,
    label: 'Cough',
    fieldName: SymptomsBooleanEnums.cough
  },
  {
    key: 3,
    label: 'Shortness of breath',
    fieldName: SymptomsBooleanEnums.sob
  },
  {
    key: 4,
    label: 'Fatigue or body aches',
    fieldName: SymptomsBooleanEnums.foba
  },
  {
    key: 5,
    label: 'Runny Nose',
    fieldName: SymptomsBooleanEnums.runnyNose
  },
  {
    key: 6,
    label: 'Loss of smell',
    fieldName: SymptomsBooleanEnums.los
  },
  {
    key: 7,
    label: 'Diarrhea',
    fieldName: SymptomsBooleanEnums.diarrhea
  },
  {
    key: 8,
    label: 'None of the above',
    fieldName: SymptomsBooleanEnums.nob
  }
];
